var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8056 2.03223H8.80555C5.25717 2.03223 2.41846 4.87094 2.41846 8.41932V12.4193C2.41846 15.9032 5.25717 18.8064 8.80555 18.8064H12.8056C16.2894 18.8064 19.1926 15.9677 19.1926 12.4193V8.41932C19.1926 4.87094 16.3539 2.03223 12.8056 2.03223ZM17.9023 12.4193C17.9023 15.1935 15.6443 17.5161 12.8056 17.5161H8.80555C5.96684 17.5161 3.70878 15.258 3.70878 12.4193V8.41932C3.70878 5.58061 5.96684 3.32255 8.80555 3.32255H12.8056C15.5797 3.32255 17.9023 5.58061 17.9023 8.41932V12.4193Z",
    fill: "#7DAD7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.354 12.8066C10.4185 12.8711 10.4831 12.9356 10.5476 12.9356C10.6121 13.0001 10.7411 13.0001 10.8056 13.0001C10.8701 13.0001 10.9992 13.0001 11.0637 12.9356C11.1282 12.8711 11.1927 12.8711 11.2572 12.8066L13.5798 10.484C13.8379 10.2259 13.8379 9.83882 13.5798 9.58076C13.3218 9.32269 12.9347 9.32269 12.6766 9.58076L11.4508 10.8066V6.03237C11.4508 5.64527 11.1927 5.38721 10.8056 5.38721C10.4185 5.38721 10.1605 5.64527 10.1605 6.03237V10.8711L8.93467 9.64527C8.6766 9.38721 8.2895 9.38721 8.03144 9.64527C7.77337 9.90334 7.77337 10.2904 8.03144 10.5485L10.354 12.8066Z",
    fill: "#7DAD7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.2568 12.9352C13.5794 14.6127 8.03103 14.6127 6.35361 12.9352C6.09555 12.6772 5.70845 12.6772 5.45038 12.9352C5.19232 13.1933 5.19232 13.5804 5.45038 13.8385C6.54716 14.9352 8.67619 15.4514 10.8052 15.4514C12.9343 15.4514 15.0633 14.9352 16.1601 13.8385C16.4181 13.5804 16.4181 13.1933 16.1601 12.9352C15.902 12.6772 15.5149 12.6772 15.2568 12.9352Z",
    fill: "#7DAD7C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.4be479767bd96a25ccf119d21391d78d.svg";
export { ForwardRef as ReactComponent };